"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = void 0;
async function reset(client) {
  let {
    blockNumber,
    jsonRpcUrl
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  await client.request({
    method: "".concat(client.mode, "_reset"),
    params: [{
      forking: {
        blockNumber: Number(blockNumber),
        jsonRpcUrl
      }
    }]
  });
}
exports.reset = reset;
//# sourceMappingURL=reset.js.map